import { render, staticRenderFns } from "./historyChatListComp.vue?vue&type=template&id=3697f563&scoped=true"
import script from "./historyChatListComp.vue?vue&type=script&lang=js"
export * from "./historyChatListComp.vue?vue&type=script&lang=js"
import style0 from "./historyChatListComp.vue?vue&type=style&index=0&id=3697f563&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3697f563",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3697f563')) {
      api.createRecord('3697f563', component.options)
    } else {
      api.reload('3697f563', component.options)
    }
    module.hot.accept("./historyChatListComp.vue?vue&type=template&id=3697f563&scoped=true", function () {
      api.rerender('3697f563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarSearch/comps/historyChatListComp.vue"
export default component.exports